import { render } from "./CamplainsScreen.vue?vue&type=template&id=77996168&scoped=true"
import script from "./CamplainsScreen.vue?vue&type=script&lang=js"
export * from "./CamplainsScreen.vue?vue&type=script&lang=js"

import "./CamplainsScreen.vue?vue&type=style&index=0&id=77996168&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77996168"]])

export default __exports__